import { AbstractModel } from './AbstractModel'
import { DateUtils } from '../utils/DateUtils'

export class FixedValueDiscount extends AbstractModel {
    name = ''
    email = ''
    customerId: number|null = null
    initialValue: number|null = null
    restValue: number|null = null
    validTil: string|null = null
    info: string|null = null
    createdAt: string|null = null
    updatedAt: string|null = null

    get validTilExternal () {
      if (this.validTil) {
        return DateUtils.dateToYodaString(new Date(this.validTil))
      }
      return ''
    }

    set validTilExternal (validTil: string) {
      this.validTil = validTil
    }

    static async getForLoggedInUser (): Promise<FixedValueDiscount[]> {
      return FixedValueDiscount.getAll({ params: ['logged-in'] })
    }
}
